/**
 * Договорённость между сборкой и SPA о том, по какому адресу лежит метод API.
 *
 * В облаке весь API обслуживает **одна** функция Yandex Cloud Functions
 * (`eleonora-api-<окружение>`): браузер вызывает её по адресу
 * `https://functions.yandexcloud.net/<идентификатор>`, а какой именно метод нужен,
 * функция узнаёт из запроса. Прямой вызов функции по идентификатору не передаёт
 * путь запроса (`event.path`), поэтому путь едет **query-параметром** `route` —
 * его видят и функции, и контейнер (см. `src/backend/handlers/api.ts`).
 *
 * `api-config.json` генерируется при деплое (`npm run build:api-config`,
 * `src/build/generateApiConfig.ts`) и **не** входит в репозиторий: адрес функции
 * известен только после её создания.
 */

/** Имя query-параметра, в котором передаётся путь API (например, `/api/health`). */
export const API_ROUTE_PARAM = 'route';

/** Содержимое `api-config.json`: путь API → адрес функции. */
export interface ApiConfig {
  /** Соответствие пути API (например, `/api/auth/login`) адресу функции. */
  endpoints: Record<string, string>;
}

/**
 * Адрес функции для пути API: базовый адрес плюс `route=<путь>`.
 * Один и тот же адрес используется для всех методов API.
 */
export function buildApiEndpoint(baseUrl: string, path: string): string {
  return `${baseUrl}?${API_ROUTE_PARAM}=${encodeURIComponent(path)}`;
}

/**
 * Приклеивает query реального запроса к адресу функции. У адреса функции уже есть
 * свой query (`route=…`), поэтому второй вопросительный знак становится `&`, иначе
 * параметры запроса попали бы в значение `route`.
 */
export function joinEndpointQuery(endpoint: string, query: string): string {
  const trimmed = query.startsWith('?') ? query.slice(1) : query;
  if (!trimmed) return endpoint;
  return `${endpoint}${endpoint.includes('?') ? '&' : '?'}${trimmed}`;
}
